export default "__VITE_ASSET__d2a357f4__$_?nuxt_component=async&nuxt_component_name=SvgoClockMinute__"